export const checkEmail_cn = {
  verify: '等待您进行验证',
  please_verify: '请验证您的电子邮箱，以免影响部分功能使用',
  look: '请查看',
  from: '来自 JCtrans 的电子邮件，用以完成您的账户激活',
  four: '请输入4位数字',
  no_receive: '没有收到我们的电子邮件？',
  refresh: '',
  refresh1: 's后重新发送',
  refresh2: '重新发送',
  sub: '提交验证',
  verify_send: '验证码已发送，请查看邮箱',
  verify: '验证码',
  verify_p: '请输入验证码',
}
export const checkEmail_en = {
  verify: 'Wait to be verified',
  please_verify: 'please verify your email address.',
  look: "We've sent an email to",
  from: 'to verify your email address and activate your account.',
  four: 'Enter 4 numbers',
  no_receive: "Can't find the email?",
  refresh: 'Resend (',
  refresh1: 'S)',
  refresh2: 'Resend',
  sub: 'Submit',
  verify_send: 'The verification code has been sent to your email',
  verify: 'Verification Code',
  verify_p: 'please enter verification code',
}
